import { shopStore } from '@/store/shop'
import { userStore } from '@/store/user'
import { stringify } from 'query-string'
import React, { createElement } from 'react'
import { RouteProps, Route, Redirect } from 'react-router'

export const AuthRouter: React.FC<RouteProps> = props => (
    <Route
        path={props.path}
        render={p => {
            if (!shopStore.shopInfo?.id && !userStore.token) {
                const search = stringify({
                    redirect: window.location.hash.replace('#', ''),
                })

                return (
                    <Redirect
                        to={{
                            pathname: '/privilege',
                            search: search,
                        }}
                    ></Redirect>
                )
            } else {
                if (props.component) {
                    return createElement(props.component, p)
                }
            }
        }}
    />
)
